<template>
  <div>
    <modal v-model="isVisible" v-if="this.sizeGridToDelete !== null">
      <div class="c-modalCard">
        <header class="c-modalCard__header">
          <h4 class="c-modalCard__title">Confirmação de Exclusão <strong>{{ this.sizeGridToDelete.code }} - {{ this.sizeGridToDelete.name }}</strong></h4>
          <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
            <i class="i-remove"></i>
          </a>
        </header>
        <div class="c-modalCard__body">
          Deseja remover a Guia de Medidas {{ this.sizeGridToDelete.name }}?
          <span>Apenas a remoção poderá ocorrer caso não aja nenhum projeto vinculado a mesma*</span>
        </div>
        <footer class="c-modalCard__footer">
          <button type="button" class="btn" v-on:click="isVisible = false">Não</button>
          <button type="button" class="btn btn--danger" @click="confirm()">Deletar</button>
        </footer>
      </div>
    </modal>
    <list :listTitle="$t('mercadoLivre.sizeGrids.label')" :loading="loading" :total="sizeGrids.length" :typesListAvailable="['displayList']" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'desc' }" @change="submit" @clearFilters="clearFilters">
      <span class="btn btn--info" slot="header-actions" @click="createSizeGrid">{{ $t('task.create.label') }}</span>
      <template slot="filters">
        <form-group label="Conta">
          <select class="form-select" v-model="account">
            <option value="">Selecione</option>
            <option v-for="account in accounts" :key="account.identifier" :value="account.identifier">
              {{ account.name }}
            </option>
          </select>
        </form-group>
        <form-group :columns="4" label="Gênero">
          <select class="form-select" v-model="gender">
            <option value="">Selecione</option>
            <option value="Sem Gênero">Sem Gênero</option>
            <option value="Masculino">Masculino</option>
            <option value="Feminino">Feminino</option>
            <option value="Menino">Menino</option>
            <option value="Menina">Menina</option>
          </select>
        </form-group>
        <form-group label="Domínio da tabela (tipo do produto)">
          <select v-model="productDomain" class="form-select">
            <option value="">Selecione</option>
            <option v-for="domain in productDomains" :key="domain" :value="domain">
              {{ domain }}
             </option>
          </select>
        </form-group>
      </template>
      <div class="l-col-12@md" v-for="(sizeGrid, index) in sizeGrids" :key="index">
        <size-grid-card :sizeGrid="sizeGrid" @getSizeGridToDelete="setSizeGridToDelete">
        </size-grid-card>
      </div>
      <div class="l-col u-textCenter" v-if="!sizeGrids.length">
        <panel>
          Nenhuma tabela de medidas encontrada
        </panel>
      </div>
    </list>
  </div>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import List from '@/components/shared/list/Paginator'
  import FormGroup from '@/components/template/FormGroup'
  import SizeGridCard from '@/components/marketplace/mercadoLivre/sizeGrid/Card'
  import Panel from '@/components/template/Panel'

  export default {
    data: () => ({
      account: '',
      gender: '',
      productDomain: '',
      accounts: [],
      productDomains: [],
      loading: true,
      sortFields: [
        'date.created'
      ],
      isVisible: false,
      sizeGrids: [],
      cancelItemFlag: false,
      cancelItem: null,
      sizeGridToDelete: null
    }),
    async mounted () {
      api.mercadoLivre.getAccounts()
        .then(data => {
          this.accounts = data.items
        })
        .catch(() => {
          notifier.error('Erro ao buscar as contas do Mercado Livre!', 'Erro')
        })

      api.mercadoLivre.getDomains()
        .then(data => {
          this.productDomains = data.items
        })
        .catch(() => {
          notifier.error('Erro ao buscar Domínios de Produtos do Mercado Livre!', 'Erro')
        })

      api.mercadoLivre.getSizeGrids({})
        .then(data => {
          this.sizeGrids = data.items
          this.loading = false
        })
        .catch(() => {
          notifier.error('Erro ao buscar as Guia de Medidas!', 'Erro')
        })
    },
    methods: {
      async confirm () {
        api.mercadoLivre.deleteSizeGrid(this.sizeGridToDelete._id.$oid)
          .then(data => {
            notifier.success('Guia de Medidas Removida com sucesso', 'Sucesso')
            this.reloadSizeGrids()
          })
          .catch(err => {
            notifier.error(err.message, 'Erro')
          })
      },
      setSizeGridToDelete (sizeGridToDelete) {
        this.isVisible = true
        this.sizeGridToDelete = sizeGridToDelete
      },
      async submit () {
        this.loading = true

        this.reloadSizeGrids()
      },
      async reloadSizeGrids () {
        let options = {
          gender: this.gender,
          account: this.account,
          domain: this.productDomain
        }

        api.mercadoLivre.getSizeGrids(options)
          .then(data => {
            this.sizeGrids = data.items
            this.loading = false
          })
          .catch(() => {
            notifier.error('Erro ao buscar as tabelas de medidas, verifique os filtros!', 'Erro')
            this.sizeGrids = []
          })

        this.loading = false
      },
      createSizeGrid () {
        return this.$router.push('/marketplace/mercadoLivre/sizegrids/create')
      },
      clearFilters () {
        this.moduleSelected = null
      }
    },
    watch: {
    },
    components: {
      List,
      FormGroup,
      SizeGridCard,
      Panel
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// List.vue?8020376e